import { useAccount } from '@/domain/hooks/useAccount'
import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { Drawer, DrawerContent } from '@/shadcn/ui/drawer'
import { Suspense, useLayoutEffect } from 'react'
import { SideDrawerSkeleton } from './components/SideDrawerSkeleton'
import { AccountOverview } from './views/AccountOverview'
import { GuestView } from './views/GuestView'

export function SideDrawer({ setMobileMenuCollapsed }: { setMobileMenuCollapsed: (open: boolean) => void }) {
  const account = useAccount()
  const { isOpen, setOpen } = useSideDrawer()

  // https://github.com/emilkowalski/vaul/issues/497
  useLayoutEffect(() => {
    function handleFocusIn(e: Event) {
      e.stopImmediatePropagation()
    }
    function handleFocusOut(e: Event) {
      e.stopImmediatePropagation()
    }

    document.addEventListener('focusin', handleFocusIn)
    document.addEventListener('focusout', handleFocusOut)

    return () => {
      document.removeEventListener('focusin', handleFocusIn)
      document.removeEventListener('focusout', handleFocusOut)
    }
  }, [])

  return (
    <Suspense fallback={null}>
      <Drawer direction="right" open={isOpen} onOpenChange={setOpen}>
        <DrawerContent className="w-full max-w-md overflow-y-scroll">
          <Suspense fallback={<SideDrawerSkeleton />}>
            {account ? <AccountOverview setMobileMenuCollapsed={setMobileMenuCollapsed} /> : <GuestView />}
          </Suspense>
        </DrawerContent>
      </Drawer>
    </Suspense>
  )
}
